module.exports = __webpack_public_path__ + "media/bootstrap-icons/tags-fill-3e3fddfe.svg";